export default class UtilGeo {
    constructor()
    {
        this.endpoint = 'https://where-am-i.teeg.cloud?geo=true'
        this.getLocation();
    }

    async getLocation() {
        // We only want to call this once per user really
        var geo = localStorage.getItem('geo');
        if(geo != null) {
            var geoData = JSON.parse(geo);
            if(typeof geoData.locale !== 'undefined') {
                return geo;    
            }
        }
        
        const response = await fetch(this.endpoint);
        const jsonData = await response.json();

        localStorage.setItem('geo', JSON.stringify(jsonData));
    }
}